import { debounce } from "lodash";
import { useListFilterContext } from "ra-core";
import { FC, createContext, useContext, useMemo, useState } from "react";
import { OfflineFileSearchInput } from "@/gen/api/securefile";



interface OfflineFileTableSearchContextProps {
  searchFileName: (s: string) => void;
  setCompleted: (x: boolean | null) => void;
  setSearchTime: (start: Date | null, end: Date | null) => void;
  states: {
    fileName: string;
    startTime: Date | null;
    endTime: Date | null;
    completed: boolean | null;
  };
}

const OfflineFileTableSearchContext = createContext<OfflineFileTableSearchContextProps>({} as any)


export const OfflineFileTableSearchProvider : FC = ({ children }) => {
  const { setFilters, displayedFilters } = useListFilterContext()
  
  const [states, setStates] = useState({
    fileName: '',
    startTime: null as Date|null,
    endTime: null as Date|null,
    completed: false as boolean|null,
  })
  
  const ctrls = useMemo(() => {
    const invokeSearch = (s1: typeof states) => {
      const input : OfflineFileSearchInput = {
        fileName: s1.fileName || null,
        completed: s1.completed,
        startTime: s1.startTime ? s1.startTime.toISOString() : null as any,
        endTime: s1.endTime ? s1.endTime.toISOString() : null,
      }
      setFilters(input, displayedFilters)
    }
  
    const debouncedInvokeSearch = debounce(invokeSearch, 300)

    return {
      searchFileName: (s: string) => {
        setStates(v => {
          if (v.fileName !== s) {
            const v1 = {...v, fileName: s}
            setTimeout(() => debouncedInvokeSearch(v1))
            return v1
          } else {
            return v
          }
        })
      },  
      setCompleted: (x: boolean|null) => {
        setStates(v => {
          if (v.completed === x) { return v }
          const v1 = {...v, completed: x}
          setTimeout(() => invokeSearch(v1))
          return v1
        })
      },
      setSearchTime: (start:Date|null, end:Date|null) => {
        setStates(v => {
          if (v.startTime === start && v.endTime === end) {
            return v
          } else {
            const v1 = {...v, startTime: start, endTime: end}
            setTimeout(() => invokeSearch(v1))
            return v1
          }
        })
      },  
    }
  }, [setFilters, displayedFilters])

  return (
    <OfflineFileTableSearchContext.Provider value={{...ctrls, states }}>
      {children}
    </OfflineFileTableSearchContext.Provider>
  )
}

export const useOfflineFileTableSearchContext = () => useContext(OfflineFileTableSearchContext)
